import { configureStore } from '@reduxjs/toolkit';
import notificationsReducer from '@/store/notificationsSlice';
import { apiSlice } from '@/store/apiSlice';

export const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

